/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import * as types from 'constants/ActionTypes';

/**
 * @typedef {{
 *   data: Record<string, import("modules/offers/types").Derivative>,
 *   isFetching: boolean,
 * }} DerivativeReducer
 */

/** @type {DerivativeReducer} */
const initialState = {
  data: {},
  isFetching: false,
};

const reducer = produce(
  /** @param {DerivativeReducer} draft  */
  (draft, action) => {
    switch (action.type) {
      case types.FETCH_DERIVATIVE_REQUEST:
        draft.isFetching = true;
        break;

      case types.FETCH_DERIVATIVE_SUCCESS:
        draft.isFetching = false;
        draft.data[action.derivativeCode] = action.derivative;
        break;

      case types.FETCH_DERIVATIVE_FAILURE:
        draft.isFetching = false;
        break;
      default:
    }
    return draft;
  },
  initialState
);
export default reducer;
